import {
  Datagrid,
  DateField,
  List,
  ResourceComponentProps,
  TextField,
} from "react-admin";

export const MachineDefinitionList = (props: ResourceComponentProps) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="type" />
      <TextField source="id" />
      <DateField source="createdAt" />
    </Datagrid>
  </List>
);
